import { render, staticRenderFns } from "./fccListaVagas.vue?vue&type=template&id=5b7dbbfe"
import script from "./fccListaVagas.vue?vue&type=script&lang=js"
export * from "./fccListaVagas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports